export default {
  metaDescription: 'Get in touch with PT Tokki Engineering and Fabrication (TEF). Contact our offices in Cikarang, Cilegon, Gresik, and Medan for sales and inquiries.',
  pageTitle: 'Contact Us',
  offices: {
    discovery: { label: 'Cikarang Factory & Office' },
    endeavor: { label: 'Cilegon Factory & Office' },
    voyager: { label: 'Gresik Branch Office' },
    frontier: { label: 'Medan Representative Office' },
  },
  salesTeam: {
    talkToOur: 'Talk to Our',
    salesTeam: 'Sales Team',
    description: 'Please fill in the form below. Our reliable team will send you a message as soon as possible and answer your extraordinary project needs.',
  },
  form: {
    name: 'Name',
    companyName: 'Company Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    message: 'Message',
    send: 'Send',
    pleaseWait: 'Please Wait...',
  },
};
